import {Injectable} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {from, Observable} from "rxjs";
import {SwitchUserModalComponent} from "./switch-user-modal.component";

@Injectable({providedIn: 'root'})
export class SwitchUserModalService {

  constructor(private modalService: NgbModal) {
  }

  open() {
    this.modalService.dismissAll();
    const modalRef = this.modalService.open(SwitchUserModalComponent,
      {windowClass: 'set-width-modal'});
    return from(modalRef.result)
  }
}
